import {gsap} from 'gsap';
( function( app ) {
  const COMPONENT = {
    init: function() {
    },
    finalize: function() {
      gsap.to( '#expanding-hero__animated-mask', {
        scale: 100,
        duration: 3,
        ease: 'power1.in',
        delay: 0.2,
      } );
      gsap.to( '#expanding-hero__animated-mask', {
        opacity: 0,
        duration: 0,
        delay: 3.2,
      } );
    },
  };

  app.registerComponent( 'expanding-hero', COMPONENT );
} )( app );
